'use client';

import ListIcon from '@mui/icons-material/List';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { FlexRow, StackRow } from '@ocodelib/mui';
import { useObservable } from '@ocodelib/mui/hooks';
import { useP5BasicApp } from '../../useP5BasicApp';

export function CodeEditorTop() {
  const { app } = useP5BasicApp();
  const editor = useObservable(app?.editor$);
  const fileListVisible = useObservable(app?.fileListVisible$) ?? false;
  const selectedFile = useObservable(app?.selectedFile$);
  const autoRefreshEnabled = useObservable(app?.autoRefreshEnabled$);

  const handleClickPlay = () => {
    if (!app) return;
    app.renderSketch();
  };

  const handleClickStop = () => {
    if (!app) return;
    app.stopSketch();
  };

  return (
    <FlexRow.Start alignItems="center" sx={{ bgcolor: '#edeff1', height: 40, pl: 1 }}>
      <Tooltip title={fileListVisible ? 'close file list' : 'open file list'}>
        <IconButton
          size="small"
          color="inherit"
          onClick={() => {
            app?.setFileListVisible((prev) => !prev);
          }}
        >
          {fileListVisible ? <MenuOpenIcon /> : <ListIcon />}
        </IconButton>
      </Tooltip>

      <Typography ml={1} variant="body2">
        {selectedFile?.name}
      </Typography>
      {editor && (
        <StackRow alignItems="center" spacing={0.5} sx={{ ml: 'auto' }}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={autoRefreshEnabled ?? false}
                  onChange={(_, checked) => {
                    app?.setAutoRefreshEnabled(checked);
                  }}
                  size="small"
                />
              }
              label="자동 실행"
            />
          </FormGroup>

          <Tooltip title="Run">
            <IconButton onClick={handleClickPlay} color="secondary" size="small">
              <PlayArrowRoundedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Stop">
            <IconButton onClick={handleClickStop} color="primary" size="small">
              <StopRoundedIcon />
            </IconButton>
          </Tooltip>
        </StackRow>
      )}
    </FlexRow.Start>
  );
}
